module.exports = __webpack_public_path__ + "static/media/401.b918b0cb.png";